/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from "react";
import { Form, FormGroup, Label, ListGroup, ListGroupItem, Row, Col } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes, { element } from "prop-types";

import { getAccountType, ArchiveTypes } from "../types";
import ModalArchive from "../../Modal/ModalArchive";
import ModalConfirm from "../../Modal/ModalConfirm";
import { CircularProgress } from "../../../..";
import { AccountMode, showToast } from "../../../../utils/Helper";
import { FormattedDate, FormattedTime } from "react-intl";

const Documents = ({
  documents,
  isReadOnly,
  archivesTypes,
  accountId,
  setAccountData,
  services,
  mode,
  refresh,
  newOnboardingVersion = false,
}) => {
  const [modalArchives, setModalArchives] = useState({
    open: false,
    loading: false,
  });
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    documentId: null,
    title: "",
    callback: undefined,
    loading: false,
  });

  useEffect(() => {
    if (mode === AccountMode.New) {
      if (documents && documents.length < 1) {
        const body = {
          AccountGetInfo: {
            GetAccountDataId: accountId,
            GetAccountDataOnboardingId: accountId,
            GetAccountDataType: getAccountType.Documents,
          },
        };
        services.fetchNewAccountInfo(body, (data) => {
          if (data && data.SDTAccount) {
            setAccountData(
              {
                AccountId: accountId,
                AccountArchives: data.SDTAccount.AccountArchives,
              },
              false
            );
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    if (mode !== AccountMode.New) {
      if (!documents) {
        const body = {
          AccountGetInfo: {
            GetAccountDataId: accountId,
            GetAccountDataType: getAccountType.Documents,
          },
        };
        services.fetchAccountSectorInfo(body, (data) => {
          if (data && data.SDTAccount) {
            setAccountData(
              {
                AccountId: accountId,
                AccountArchives: data.SDTAccount.AccountArchives,
              },
              false
            );
          }
        });
      }
    }
  }, [accountId, archivesTypes, setAccountData, services]);

  const handleSaveFile = (archive) => {
    if(newOnboardingVersion){
      const archiveName = archive.ArchivesName || archive.AccountArchivesName || "";
      if (archiveName && archiveName.length > 30) {
        showToast("error: the file name must not exceed 30 characters", true);
        setModalArchives({
          open: true,
          loading: false,
        });
        return;
      }
    }
    if (
      ["pdf", "csv", "doc", "docx", "xls", "xlsx", "jpg", "jpeg", "png"].includes(
        archive.ArchivesExtension.toLowerCase()
      )
    ) {
      const newArchive = {};
      Object.keys(archive).map((key) => {
        newArchive[`Account${key}`] = archive[key];
        return {};
      });

      const body = {
        account: {
          AccountId: accountId,
          AccountOnboardingId: accountId,
          AccountArchives: [newArchive],
        },
        accountChangeType: getAccountType.Documents,
      };
      setModalArchives((m) => ({
        ...m,
        loading: true,
      }));
      if (mode !== AccountMode.New) {
        const updatedBody = {
          ...body, 
          account: {
            ...body.account, 
            isOnboardingAccount: newOnboardingVersion ? true : false,
          },
        };
        services.fetchAccountUpdate(updatedBody, (response) => {
          if (response && response.result && response.result.Code === 200) {
            const newDocument = body.account.AccountArchives[0];
            newDocument.AccountArchiveId = response.Id;
            documents.push(newDocument);
            setModalArchives({
              open: false,
              loading: false,
            });
            setAccountData(
              {
                AccountId: accountId,
                AccountArchives: documents,
              },
              true
            );
          }
        });
      } else {
        services.fetchNewAccount(body, (response) => {
          if (response && response.result && response.result.Code === 200) {
            const newDocument = body.account.AccountArchives[0];
            newDocument.AccountArchiveId = response.Id;
            documents.push(newDocument);
            setModalArchives({
              open: false,
              loading: false,
            });
            setAccountData(
              {
                AccountId: accountId,
                AccountArchives: documents,
              },
              true
            );
            refresh();
          }
        });
      }
    } else {
      showToast("error: the file must be pdf, csv, doc, docx, xls or xlsx", true);
      setModalArchives({
        open: true,
        loading: false,
      });
    }
  };

  const handleDeleteFile = (documentId) => {
    const body = {
      account: {
        AccountId: accountId,
        AccountOnboardingId: accountId,
        AccountArchives: [
          {
            AccountArchiveId: documentId,
          },
        ],
      },
      accountChangeType: getAccountType.Documents,
    };
    setModalConfirm((m) => ({
      ...m,
      loading: true,
    }));
    if (mode !== AccountMode.New) {
      const updatedBody = {
        ...body, 
        account: {
          ...body.account, 
          isOnboardingAccount: newOnboardingVersion ? true : false,
        },
      };
      services.fetchAccountUpdate(updatedBody, (response) => {
        if (response && response.result && response.result.Code === 200) {
          let index = -1;
          documents.map((doc, i) => {
            if (doc.AccountArchiveId === documentId) {
              index = i;
            }
            return {};
          });
          if (index > -1) {
            documents.splice(index, 1);
          }
          setAccountData(
            {
              AccountId: accountId,
              AccountArchives: documents,
            },
            true
          );
          setModalConfirm({
            open: false,
            documentId: null,
            title: "",
            callback: undefined,
            loading: false,
          });
        }
      });
    } else {
      services.fetchNewAccount(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          let index = -1;
          documents.map((doc, i) => {
            if (doc.AccountArchiveId === documentId) {
              index = i;
            }
            return {};
          });
          if (index > -1) {
            documents.splice(index, 1);
          }
          setAccountData(
            {
              AccountId: accountId,
              AccountArchives: documents,
            },
            true
          );
          setModalConfirm({
            open: false,
            documentId: null,
            title: "",
            callback: undefined,
            loading: false,
          });
          refresh();
        }
      });
    }
  };

  const toggleModalConfirm = (id) =>
    setModalConfirm((m) => {
      const newM = {
        ...m,
        open: !m.open,
      };
      if (id) {
        newM.title = "Are you sure you want to remove the selected Document?";
        newM.callback = () => handleDeleteFile(id);
      }
      return newM;
    });

  const toggleModalDoc = () => {
    const archiveSubytpeExists =
      Object.keys(archivesTypes[ArchiveTypes.Account]).length > 0 &&
      Object.keys(archivesTypes[ArchiveTypes.Account].ArchivesSubTypes).length > 0;
    if (archiveSubytpeExists) {
      setModalArchives((m) => ({
        open: !m.open,
        loading: false,
      }));
    } else {
      alert(
        "No Archives Subtypes entered in the system.\nTo add files go to:\nParameteres -> Archive Subtypes"
      );
    }
  };

  if (!documents || !archivesTypes) {
    return <CircularProgress sm />;
  }

  const getFile = (file) => {
    const body = {
      accountId: accountId,
      archiveId: file.AccountArchiveId,
    };
    services.getAccountArchive(body, (response) => {
      var a = document.createElement("A");
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.AccountArchivesName}.${file.AccountArchivesExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  const getOnboardingFile = (file) => {
    const body = {
      fileId: file.AccountArchiveId,
      onboarding: accountId,
    };
    if (body.fileId == "") {
      const fileId = documents.findIndex((d) => (d.AccountArchivesName).trim().toLowerCase() === file.AccountArchivesName.trim().toLowerCase()) + 1;
      body.fileId = fileId;
    }
    services.getOnboardingAccountArchive(body, (response) => {
      var a = document.createElement("A");
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.AccountArchivesName}.${file.AccountArchivesExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {documents.map((d, i) => (
              <ListGroupItem key={d.AccountArchiveId}>
                <Label>
                  <span style={{ fontSize: "15px", fontWeight: 500 }}>
                    {d.AccountArchivesSubTypeDescription}
                    {":   "}
                  </span>
                  <i className={d.AccountArchivesExtension === "pdf" ? "fa fa-file-pdf-o" : "fa fa-file"} />
                  {mode !== AccountMode.New ? (
                    <a
                      onClick={() => getFile(d)}
                      style={{ cursor: "pointer" }}
                      /*href={`data:application/octet-stream;base64,${d.AccountArchivesBlob}`} 
                    download={`${d.AccountArchivesName}.${d.AccountArchivesExtension}`}*/
                    >
                      {" "}
                      {d.AccountArchivesName}
                    </a>
                  ) : (
                    <a
                      onClick={() => getOnboardingFile(d)}
                      style={{ cursor: "pointer" }}
                      /*href={`data:application/octet-stream;base64,${d.AccountArchivesBlob}`} 
                    download={`${d.AccountArchivesName}.${d.AccountArchivesExtension}`}*/
                    >
                      {" "}
                      {d.AccountArchivesName}
                    </a>
                  )}

                  {d.AccountArchivesEnabled && (
                    <Row>
                      <Col>
                        <span style={{ fontSize: "15px", fontWeight: 500 }}>
                          {"Expiration Date: "}
                          {new Date(d.AccountArchivesExpirationDate).toLocaleDateString("es") ===
                          "Invalid Date"
                            ? "No Expiration"
                            : new Date(d.AccountArchivesExpirationDate).toLocaleDateString("es")}
                        </span>
                      </Col>
                    </Row>
                  )}
                </Label>
                {!isReadOnly && (
                  <div
                    style={{ cursor: "pointer", float: "right" }}
                    onClick={() => toggleModalConfirm(d.AccountArchiveId)}
                  >
                    <i className="fa fa-trash" />
                  </div>
                )}
              </ListGroupItem>
            ))}
          </ListGroup>
        </FormGroup>
      </Form>
      {!isReadOnly && (
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={false}
          style={{ marginRight: 10 }}
          onClick={toggleModalDoc}
          data-style={EXPAND_RIGHT}
        >
          <i className="fa fa-plus" /> Add New Document
        </LaddaButton>
      )}
      {modalArchives.open && (
        <ModalArchive
          {...modalArchives}
          archiveType={archivesTypes[ArchiveTypes.Account]}
          onSave={handleSaveFile}
          onToggle={toggleModalDoc}
        />
      )}
      <ModalConfirm
        open={modalConfirm.open}
        toggle={toggleModalConfirm}
        saving={modalConfirm.loading}
        callback={modalConfirm.callback}
        title={modalConfirm.title}
      />
    </div>
  );
};

Documents.propTypes = {
  accountId: PropTypes.string.isRequired,
  archivesTypes: PropTypes.object,
  documents: PropTypes.array,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
};

Documents.defaultProps = {
  archivesTypes: undefined,
  documents: undefined,
};

export default Documents;
